import React, { Component } from 'react';
import SelectProvince from './SelectProvince';

class SelectAreaCity extends Component {
    render() {
        const { value = [], onChange, ...rest } = this.props;
        let areaName = [],
            hasCheckedArea = [];
        value.forEach(item => {
            areaName.push(item.props.title);
            hasCheckedArea.push(item.key);
        });
        return (
            <SelectProvince
                areaName={areaName}
                saveProvince={onChange}
                hasCheckedArea={hasCheckedArea}
                {...rest}
            />
        );
    }
}

export default SelectAreaCity;


// WEBPACK FOOTER //
// ./src/components/common/SelectAreaCity.js